import css from '../images/logos/css.svg'
import docker from '../images/logos/docker.svg'
import express from '../images/logos/express.svg'
import git from '../images/logos/git.svg'
import html from '../images/logos/html.svg'
import javascript from '../images/logos/javascript.svg'
import matplotlib from '../images/logos/matplotlib.svg'
import nodejs from '../images/logos/nodejs.svg'
import numpy from '../images/logos/numpy.svg'
import pandas from '../images/logos/pandas.svg'
import python from '../images/logos/python.svg'
import raspberrypi from '../images/logos/raspberrypi.svg'
import react from '../images/logos/react.svg'
import sass from '../images/logos/sass.svg'
import scrapy from '../images/logos/scrapy.svg'
import seaborn from '../images/logos/seaborn.svg'
import sklearn from '../images/logos/sklearn.svg'
import tensorflow from '../images/logos/tensorflow.svg'
import vscode from '../images/logos/vscode.svg'

const logos =  {
    'css' : css,
    'docker' : docker,
    'express' : express,
    'git' : git,
    'html' : html,
    'javascript' : javascript,
    'matplotlib' : matplotlib,
    'nodejs' : nodejs,
    'numpy' : numpy,
    'pandas' : pandas,
    'python' : python,
    'raspberrypi' : raspberrypi,
    'react' : react,
    'sass' : sass,
    'scrapy' : scrapy,
    'seaborn' : seaborn,
    'sklearn' : sklearn,
    'tensorflow' : tensorflow,
    'vscode' : vscode,
}

export default logos